import { HashRouter as Router } from "react-router-dom";
import LoadingProvider from "./context/LoadingProvider";
import AppProvider from "./context/AppProvider";
import UserTrazabilityProvider from "./context/UserTrazabilityContext";
import UserPermisionsProvider from "./context/UserPermisionsContext";
import UserProfileProvider from "./context/UserProfileContext";
import Routes from "./routes/Routes";
import { ToastContainer } from "react-toastify";

import "ypf-pas-general-ui-components/dist/styles.css";
import "./styles/styles.scss";

function App() {
  return (
    <LoadingProvider>    
      <Router basename="/">
        <ToastContainer className="toast-container" limit={5} newestOnTop />
          <AppProvider>
            <UserPermisionsProvider>
              <UserProfileProvider>
                <UserTrazabilityProvider>
                  <Routes />
                </UserTrazabilityProvider> 
              </UserProfileProvider>
            </UserPermisionsProvider>       
          </AppProvider>
        </Router>         
    </LoadingProvider>
  );
}

export default App;
